import Types from "./types";

const setGaSource = (source) => ({
    type: Types.SET_GA_SOURCE,
    source
});

export {
    setGaSource
};
